import * as React from 'react';
import { ChangeEvent } from 'react';
import { Limiter } from '../../Helpers/Limiter';
import { Trans } from '../Trans';

export interface SearchFieldProps {
    value: string,
    onChange: (value: string, event: ChangeEvent<HTMLInputElement>) => void
    placeholder?: string
}

export interface SearchFieldState {
    value: string
}

export class SearchField extends React.Component<SearchFieldProps, SearchFieldState> {
    private limiter: Limiter;

    constructor(props: SearchFieldProps, context: any) {
        super(props, context);

        this.handleChange = this.handleChange.bind(this);
        this.limiter = new Limiter(500);

        this.state = {
            value: props.value
        };
    }

    public render() {
        return <div className="job-center-filter-field job-center-filter-field-search-term">
            <label>
                <span className="sr-only"><Trans>Suchbegriff</Trans></span>
                <i className="fas fa-search"/>
                <input type="search"
                       value={this.state.value}
                       onChange={this.handleChange}
                       placeholder={this.props.placeholder}/>
            </label>
        </div>;
    }

    private handleChange(event: ChangeEvent<HTMLInputElement>) {
        const value = event.target.value;
        this.setState({value});
        this.limiter.execute(() => {
            this.props.onChange(value, event);
        });
    }
}
